import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/leadActivitySagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import DatePicker from "./smartComponents/DatePicker";
import AddTrackDropdown from "./smartComponents/AddTrackDropdown";
import FiltersList from "./smartComponents/FiltersList";
import LeadActivityTable from "./smartComponents/LeadActivityTable";
import FilterDropdown from "./smartComponents/FilterDropdown";
import { UpdateBtns } from "./smartComponents/updateButtons";
import { DataPoints } from "./smartComponents/DataPoints";
import HideActionsButton from "./smartComponents/HideActionsButton";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import "./leadActivity.scss";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

const LeadActivityModule = (props) => {
  const dispatch = useDispatch();
  const initialRequest = useSelector((state) => state.leadActivity.initialRequest);
  const mainFilterLoading = useSelector((state) => state.leadActivity.mainFilterLoading);
  const mainFilters = useSelector((state) => state.leadActivity.mainFilters);
  const isSelectedAction = useSelector((state) => state.leadActivity.isSelectedAction);
  const {
    filter_by_values,
    date_by,
    filter_by,
    start_from,
    condition,
    selectedRequestDates: { startDate, endDate }
  } = mainFilters.selectedFilters;
  const isLoading = useSelector((state) => state.leadActivity.isLoading);
  const isHideActions = useSelector((state) => state.leadActivity.isHideActions);
  const filtersList = useSelector((state) => state.leadActivity.filtersList);
  const tableLoading = useSelector((state) => state.leadActivity.tableLoading);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  return (
    <SectionToggle
      isLoading={isLoading}
      title="Lead Activity"
      autoHeight
      learnMore={
        <KBLearnMore
          title="Lead Activity"
          description="This report shows detailed lead activity based on selected filters, helping you define when tracking begins and narrow results by date, prospect type, or referral source. These insights help you evaluate lead engagement and tailor reports for both broad and detailed views of customer behavior."
          kbUrl={ILEARN_URLS.salesActivity.leadActivity}
        />
      }
      content={
        <div id="lead-activity">
          {props.showModule ? (
            <div id="override-edit-selection-bar" className="edit-selections-bar">
              <div className="filters-wrapper">
                <div className="filters-list">
                  <FilterDropdown
                    width="140px"
                    options={mainFilters.start_from}
                    selectedOption={start_from}
                    title="Start From"
                    keyName="start_from"
                  />
                  <FilterDropdown
                    width="170px"
                    options={mainFilters.condition}
                    selectedOption={condition}
                    title="And/Or"
                    keyName="condition"
                    disabled={filtersList.length < 2}
                    includeFilter={false}
                  />
                  {start_from.id === "lead" ? null : (
                    <FilterDropdown
                      width="170px"
                      options={mainFilters.date_by}
                      selectedOption={date_by}
                      title={`${start_from.name} Date`}
                      keyName="date_by"
                      includeFilter={false}
                    />
                  )}
                  <FilterDropdown
                    width="170px"
                    options={mainFilters.filter_by}
                    selectedOption={filter_by}
                    title="Filter By"
                    keyName="filter_by"
                    includeFilter={false}
                  />
                  <FilterDropdown
                    width="170px"
                    options={mainFilters.filter_by_values}
                    selectedOption={filter_by_values}
                    title={filter_by?.name || filter_by[0]?.name}
                    isLoading={mainFilterLoading}
                    keyName="filter_by_values"
                    includeSelectAll
                    numberDisplayed={0}
                    enableOnly
                  />

                  <DatePicker
                    startDate={startDate}
                    endDate={endDate}
                    isLeadSelected={start_from.id === "lead"}
                    zIndex={10}
                  />
                  {filtersList.length ? <HideActionsButton /> : null}
                </div>
                {!isHideActions && <FiltersList />}

                <div>
                  <AddTrackDropdown />
                  <UpdateBtns />
                </div>
              </div>
              {tableLoading ? (
                <LoadingAnimation />
              ) : isSelectedAction ? (
                <>
                  <DataPoints />
                  <LeadActivityTable />
                </>
              ) : (
                <div className="error">Please select at least one Action.</div>
              )}
            </div>
          ) : (
            <div className="error">
              Not Available in All Stores View, when user selected more than 100 stores
            </div>
          )}
        </div>
      }
    />
  );
};

export default LeadActivityModule;
